"use client";
import React from 'react';
import { ModuleFeature } from './ModuleFeature';
import { AuthenticatorIcon } from './AuthenticatorIcon';
import { InvoiceIcon } from './InvoiceIcon';
import { InventoryIcon } from './InventoryIcon';
import { PointOfSalesIcon } from './PointOfSalesIcon';
import { LoyaltyIcon } from './LoyaltyIcon';

export const SectionModules = () => {
  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />
      <section className="w-full bg-white min-h-screen">
        <div className="px-10 py-20 mx-auto max-w-[1151px] max-md:px-6 max-md:py-16 max-sm:px-4 max-sm:py-10">
          <header className="mb-20 text-center max-sm:mb-16">
            <h1 className="mb-4 text-5xl font-bold text-teal-600 leading-[56px] max-md:text-4xl max-md:leading-10 max-sm:text-3xl max-sm:leading-10">
              One Unified OS. Powerful Modules.
            </h1>
            <p className="text-lg leading-7 text-amber-500 max-sm:text-base max-sm:leading-6">
              Our interconnected modules work in perfect harmony to eliminate
              friction and drive growth.
            </p>
          </header>

          <div className="flex flex-col gap-32 max-md:gap-24 max-sm:gap-20">
            <ModuleFeature
              icon={AuthenticatorIcon}
              title="Authenticator"
              description="Eliminate fake items and build customer trust with our QR-based authentication engine."
              reverse={false}
            />

            <ModuleFeature
              icon={InvoiceIcon}
              title="Invoice"
              description="Transition from manual paperwork to a streamlined, automated invoicing engine."
              reverse={true}
            />

            <ModuleFeature
              icon={InventoryIcon}
              title="Inventory + Accounting"
              description="A powerful core for your inventory, purchasing, and sales operations."
              reverse={false}
            />

            <ModuleFeature
              icon={PointOfSalesIcon}
              title="Point of Sales"
              description="Transform your checkout experience with a flexible, cloud-based cashier system."
              reverse={true}
            />

            <ModuleFeature
              icon={LoyaltyIcon}
              title="Loyalty"
              description="Build lasting customer relationships with a flexible rewards engine designed for modern SMMEs."
              reverse={false}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default SectionModules;
